<div *ngIf="userInContext">
    <div *ngIf="!isMobile" id="feedback-nav" class="rotate-270">
        <a
            href="javascript:void(0)"
            class="feedback-link"
            id="open-form-btn"
            (click)="openForm($event)"
        >
            <lsq-icon
                class="chevron-icon"
                [ngClass]="{ 'rotate-180': !displayForm }"
                [type]="icons.ChevronDown"
                [color]="color.White"
            >
            </lsq-icon>
            <span class="text-uppercase">{{ sideButtonText }}</span>
        </a>
    </div>

    <div
        *ngIf="displayForm"
        id="feedback-form-tour"
        class="feedback-form"
        [ngClass]="{ 'mobile-feedback': isMobile }"
        (clickOutside)="close()"
        clickOutsideEvents="mouseup"
        exclude="#feedback-nav, ngx-guided-tour, .feedback-link"
    >
        <div *ngIf="isMobile" class="mobile-close" (click)="close()">
            <lsq-icon [type]="icons.Close" width="15" height="15" [color]="color.White"> </lsq-icon>
        </div>
        <div *ngIf="formSubmitted === false">
            <form [formGroup]="formGroup" (ngSubmit)="handleSubmit($event)">
                <p id="form-title">{{ formTitle }}</p>
                <ul
                    class="list-inline stars"
                    *ngIf="displayRatingStars"
                    (mouseleave)="handleMouseLeave()"
                >
                    <li
                        class="cursor-pointer"
                        *ngFor="let star of starArray; let i = index"
                        (mouseenter)="handleMouseEnter(i + 1)"
                    >
                        <lsq-icon
                            [type]="icons.Star"
                            [color]="getStarColor(i + 1)"
                            (click)="selectRating(i + 1)"
                        ></lsq-icon>
                    </li>
                </ul>
                <lsq-textarea
                    rows="5"
                    formControlName="message"
                    [labelRows]="2"
                    [group]="formGroup"
                    name="feedbackTextarea"
                    [showError]="false"
                    [label]="messageLabel"
                >
                </lsq-textarea>
                <lsq-button
                    type="submit"
                    [disabled]="shouldDisableSubmit()"
                    size="block"
                    class="submit-button"
                >
                    Submit
                </lsq-button>
            </form>
        </div>
        <div *ngIf="formSubmitted">
            <div id="response-message" class="centerText">{{ responseMessage }}</div>
            <a class="close-button" (click)="close()">CLOSE</a>
        </div>
    </div>
</div>
